import { useEffect, useRef, useState } from "react";
import { useReducedMotion } from "framer-motion";

// UX_MOTION.md "Stat cards": count-up 0->value over --dur-count (600ms), --ease-out. On a
// refresh (value changes after mount) it ROLLS old->new rather than a hard swap. Reduced-motion
// disables the tween entirely (build-blocking) — value is set instantly.
const DUR_COUNT_MS = 600;
function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

export function useCountUp(targetValue) {
  const reducedMotion = useReducedMotion();
  const [display, setDisplay] = useState(reducedMotion ? targetValue : 0);
  const fromRef = useRef(0);
  const rafRef = useRef(null);

  useEffect(() => {
    if (targetValue == null) return;
    if (reducedMotion) {
      setDisplay(targetValue);
      return;
    }
    const from = fromRef.current;
    const to = targetValue;
    const start = performance.now();
    cancelAnimationFrame(rafRef.current);
    const tick = (now) => {
      const progress = Math.min(1, (now - start) / DUR_COUNT_MS);
      setDisplay(Math.round(from + (to - from) * easeOut(progress)));
      if (progress < 1) rafRef.current = requestAnimationFrame(tick);
      else fromRef.current = to;
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetValue, reducedMotion]);

  return display;
}
